import { resolveIslandState, type IslandColor } from './agent-task-buckets';
import { islandCountsFromRows, useAgentWorkspaceTasks } from './agent-workspace-tasks';

export interface IslandState {
  /** green = resting (agents · skills), blue = in motion, orange = waiting on you. */
  color: IslandColor;
  inMotionCount: number;
  waitingCount: number;
}

/**
 * The top-bar island's resolved state. In motion (blue) = the in-progress bucket across every workspace
 * — tasks open now; attention (orange) = waiting (ACTION_NEEDED); a failed task is finished, not waiting on anyone, and lives on the Failed tab. While the
 * workspace tasks are still loading there are no rows, so counts are zero and the island rests green,
 * exactly the pre-data state. The single source both the pill and its quick-view read.
 */
export function useIslandState(): IslandState {
  const tasksState = useAgentWorkspaceTasks();
  const rows = tasksState.status === 'ready' ? tasksState.data.workspaces : [];
  const counts = islandCountsFromRows(rows);
  return { color: resolveIslandState(counts), ...counts };
}
